export default __webpack_public_path__ + "static/media/JTs-Web-Banner.737a1072.webp";